import { Route } from "react-router-dom";
import ProtectedRoute from "../protectedRoute";
import {
  COMMON_PERMISSIONS,
  MODULES_LIST,
  SUB_MODULES_LIST,
} from "../../../utils/helper";
import ManageDepartment from "../../main/configuration/manageDepartment/page";
import ManageDesignation from "../../main/configuration/manageDesignation/page";
import CommonRoute from "../commonRoute";
import ManageLeaveSetup from "../../main/configuration/manageLeaveSetup/page";
import ManageBranch from "../../main/configuration/manageBranch/page";
import Leads from "../../main/leads/page";
import AddLeads from "../../main/leads/addLead";

const leadsRoute = [
  {
    path: "/leads",
    element: <Leads />,
    // access: [COMMON_PERMISSIONS.VIEW],
    // module: MODULES_LIST.BASIC_SETUP,
    // subModule: SUB_MODULES_LIST.BASIC_SETUP.DEPARTMENT,
  },
  {
    path: "/leads/add",
    element: <AddLeads />,
    // access: [COMMON_PERMISSIONS.VIEW],
    // module: MODULES_LIST.BASIC_SETUP,
    // subModule: SUB_MODULES_LIST.BASIC_SETUP.DEPARTMENT,
  },
  {
    path: "/leads/manage-designation",
    element: <ManageDesignation />,
    access: [COMMON_PERMISSIONS.VIEW],
    module: MODULES_LIST.BASIC_SETUP,
    subModule: SUB_MODULES_LIST.BASIC_SETUP.DESIGNATION,
  },
  {
    path: "/leads/leave-setup",
    element: <ManageLeaveSetup />,
    access: [COMMON_PERMISSIONS.VIEW],
    module: MODULES_LIST.BASIC_SETUP,
    subModule: SUB_MODULES_LIST.BASIC_SETUP.LEAVE_TYPE,
  },
  {
    path: "/leads/manage-branch",
    element: <ManageBranch />,
    access: [COMMON_PERMISSIONS.VIEW],
    module: MODULES_LIST.BASIC_SETUP,
    // subModule: SUB_MODULES_LIST.BASIC_SETUP.LEAVE, // No branch submodule defined
  },
  
];

export default function renderLeadsRoutes() {
  const renderRoute = (route, access = false) => {
    if (route.children && route.children.length > 0) {
      return (
        <Route
          key={route.path}
          path={route.path}
          element={
            <ProtectedRoute
              module={route.module}
              submodule={route.subModule}
              // access={route.access}
              path={route.path}
            >
             
            </ProtectedRoute>
          }
        >
          {/* Render child routes without extra permission checks */}
          {route.children.map((child) => (
            <Route key={child.path} path={child.path} element={child.element} />
          ))}
        </Route>
      );
    }
    return (
      <Route
        key={route.path}
        path={route.path}
        element={
          access ? (
            route.element
          ) : (
            <ProtectedRoute
              module={route.module}
              submodule={route.subModule}
              // access={route.access}
              path={route.path}
            >
              {route.element}
            </ProtectedRoute>
          )
        }
      />
    );
  };
  return leadsRoute.map((route) => renderRoute(route));
}
